import React from 'react';
import './WebinarExhibitor.scss';
import { makeStyles } from '@material-ui/styles';
import { Link as LinkScroll } from 'react-scroll';
import ButtonBase from '../../Buttons/ButtonBase';

const useStyles = makeStyles({
    container: {
        justifyContent: 'center'
    },
    buttonStyle: {
        
        minWidth: 293,
    }
})

const WebinarExhibitor = () => {
    const handleScroll = () => {
        console.log('scroll arriba');
    }
    const classes = useStyles()

    return ( 
        <section className="wbExh">
            <div className="wbExh_container">
                <div class="wbExh_container-grid">
                    <div class="wbExh_container-grid__Title">
                        <p className="wbExh_title">
                            Aprenda como el <span className="wbExh_title-bold">posicionamiento web</span> se ha vuelto 
                            <span className="wbExh_title-bold"> indispensable</span> para la contratación de servicios legales. 
                        </p>
                    </div>
                    <div class="wbExh_container-grid__Info">
                        <div class="wbExh_container-grid__img-m">
                            <img className="wbExh_items-img" src="/img/Webinar/Exhibitor/ms-like.svg" alt="Chat" />
                        </div>
                        <div class="wbExh_container-grid__text-m">
                            <p className="wbExh_items-text">
                                Le proporcionaremos conceptos sobre el <span className="wbExh_title-bold">marketing digital</span> para abogados.
                            </p>
                        </div>
                        <div class="wbExh_container-grid__img-d">
                            <img className="wbExh_items-img" src="/img/Webinar/Exhibitor/graph.svg" alt="Grafica" />
                        </div>
                        <div class="wbExh_container-grid__text-d">
                            <p className="wbExh_items-text">
                            Adquiera los conocimientos para el buen uso de <span className="wbExh_title-bold">herramientas digitales </span>
                             para los profesionales del derecho.
                            </p>
                        </div>
                        <div class="wbExh_container-grid__img-v">
                            <img className="wbExh_items-img" src="/img/Webinar/Exhibitor/notify.svg" alt="Notificacion" />
                        </div>
                        <div class="wbExh_container-grid__text-v">
                            <p className="wbExh_items-text">
                                Conozca como construir un sólido posicionamiento en línea para dar mejor <span className="wbExh_title-bold">visibilidad </span>
                                 a sus servicios.
                            </p>
                        </div>
                        <div class="wbExh_container-grid__btn">
                            <LinkScroll to="webinarForm" smooth="true" duration={500} offset={-60}>
                                <ButtonBase
                                    type="submit"
                                    onClick={handleScroll}
                                    variant="secondary"
                                    linkStyle={classes.linkStyle}
                                    buttonStyle={classes.buttonStyle}
                                >
                                    Quiero asistir al webinar
                                </ButtonBase>
                            </LinkScroll>
                        </div>
                    </div>
                    <div class="wbExh_container-grid__Exhibitor">
                   
                        <div className="wbExh_img-main">
                            <img  src="/img/Webinar/Exhibitor/MartinCastro.png" alt="Notificacion" />
                        </div>
                        <div className="wbExh_container-exhibitor">
                            <div className="wbExh_container-exhibitor__main">
                                <p className="wbExh_container-exhibitor__textWebinar">Webinar impartido por</p>
                                <p className="wbExh_container-exhibitor__titleWebinar">Martín Castro, CEO de Contacta Abogado®</p>
                            </div>
                        </div>
                        <div>
                            <p className="wbExh_container-exhibitor__text">
                            <span className="wbExh_title-bold">10 años de experiencia</span> en el mundo digital, publicidad, start up´s de e-commerce, e-business, 
                            <span className="wbExh_title-bold"> social media y en diferentes industrias </span> 
incluido Legaltech.
                            </p>
                        </div>
                        <div>

                        </div>
                    </div>
                </div>
            </div>



           
        </section>
     );
}
 
export default WebinarExhibitor;